import { render, staticRenderFns } from "./LiquidacionDetalleRow.vue?vue&type=template&id=367c5184"
import script from "./LiquidacionDetalleRow.vue?vue&type=script&lang=js"
export * from "./LiquidacionDetalleRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports